<template>
    <ModalFormCard class="modal-default"
        :action='"/zapo/landing-page/review" + (editingModel?.id ? "/" + editingModel.id : "")'
        :submittedCallback='submittedCallback'
    >
        <template #title>{{ editingModel?.id ? "Edit" : "New" }} review</template>

        <template #default="{ saving, errors }">
            <input type="hidden" :value="options?.lp?.id" name="lp_id" />

            <div class='pb-4' v-if='editingModel.source'>
                <div class='flex items-center'>
                    <p class='text-15 font-semibold'>Review came from</p>
                    <component :is='"IconSource"+$help.capitalizeFirstLetter(editingModel.source.source)' class='w-4.5 h-4.5 ml-2 mr-1' />
                    <a class='text-15 font-semibold link-text capitalize' :href='editingModel.source.source_url' target='_blank'>{{ editingModel.source.source }}</a>
                </div>
                <div class='flex items-center pt-2'>
                    <template v-if='true'>
                        <IconAlert class='w-4.5 h-4.5 stroke-red-700' />
                        <p class='text-14 pl-2'>Not verified yet</p>
                    </template>
                </div>
            </div>

            <Input
                v-model:value="value.title"
                groupClass="bg-grey text-15"
                label="Title"
                name="title"
                placeholder="Title"
            />

            <Select
                v-model:value="value.stars"
                groupClass="bg-grey text-15" class=' mt-4'
                label="Stars"
                name="stars"
                placeholder="Stars"
                :options="[{value: 5 }, {value: 4 }, {value: 3 }, {value: 2 }, {value: 1 }]"
            >
                <template #option="{ option }">
                    <div class='flex items-center gap-x-0.5'>
                        <IconStar class='w-4 h-4 stroke-red-500 fill-red-500' v-for='i in option.value' :key='i' />
                    </div>
                </template>
            </Select>

            <Textarea
                v-model:value="value.review"
                name="review"
                groupClass="bg-grey text-15" class=' mt-4'
                label="Review" rows='10'
            />

            <Input
                v-model:value="value.from"
                groupClass="bg-grey text-15" class=' mt-4'
                label="From"
                name="from"
                placeholder="From"
            />

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default">
                    {{ value.id ? 'Update' : 'Create' }} review
                </ButtonSaving>

                <button class="h-12 button-purple" v-if="value.id" @click="destroy" type='button'>
                    Delete review
                </button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        created() {
            this.value = {
                id: this.editingModel?.id,
                title: this.editingModel?.title,
                stars: this.editingModel?.stars,
                review: this.editingModel?.review,
                from: this.editingModel?.from
            }
        },

        methods: {
            submittedCallback() {
                this.$event.$emit('modal-form-completed')
                this.$event.$emit('modal-close')
                this.$event.$emit('refresh-lp-preview')
            },

            destroy() {
                this.$axios.delete('/zapo/landing-page/review/' + this.value.id).then(() => {
                    this.submittedCallback()
                });
            }
        }
    }
</script>